import { render, staticRenderFns } from "./edit-wizard.vue?vue&type=template&id=4713ae44&scoped=true&"
import script from "./edit-wizard.vue?vue&type=script&lang=ts&"
export * from "./edit-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./edit-wizard.vue?vue&type=style&index=0&id=4713ae44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713ae44",
  null
  
)

export default component.exports